import { Tabs as VerticalTab, TabsContent as VerticalTabsContent, TabsList as VerticalTabsList, TabsTrigger as VerticalTabsTrigger } from "../ui/VerticalTabs"
import { MdPerson4, MdSettings, MdWidgets } from "react-icons/md"
import { Label } from "../ui/label"
import { Switch } from "../ui/switch"
import useSettingsStore from "@/store/SettingsStore"
import { FaBrush, FaMusic, FaPalette, FaPlus, FaTrash } from "react-icons/fa"
import { wallpapers } from "@/lib/constant"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog"
import { Tabs, TabsList, TabsTrigger } from "../ui/tabs"
import { useState } from "react"
import ImageUploader from "../ImageUploader"
import useMethodStore from "@/store/MethodStore"
import { Separator } from "../ui/separator"
import { IoChatbubble, IoMenu } from "react-icons/io5"
import ChatSettings from "../settings/ChatSettings"
import { FaX } from "react-icons/fa6"
import AboutSettings from "../settings/AboutSettings"

export type settingsTabTypes = "general" | "wallpapers" | "appearance" | "music" | "about" | "chat" | "widgets"

const labelStyling = "flex justify-between p-3 space-x-6 rounded-md text-zinc-900 bg-zinc-300 hover:bg-zinc-400/60 dark:text-zinc-100 dark:bg-zinc-800 dark:hover:bg-zinc-700/55 transition-colors duration-200 border-zinc-200 dark:border-zinc-800 w-full"

function Settings() {
  const [previewWallpaper, setPreviewWallpaper] = useState<string | null>(null)
  const [isOpen, setIsOpen] = useState(false)

  const setTheme = useSettingsStore(state => state.setTheme)
  const setNotificationOnMusicPlay = useSettingsStore(state => state.setNotificationOnMusicPlay)
  const addWidget = useSettingsStore(state => state.addWidget)
  const removeWidget = useSettingsStore(state => state.removeWidget)
  const removeCustomWall = useSettingsStore(state => state.removeCustomWall)
  const setActiveTab = useSettingsStore(state => state.setActiveTab)
  const setBackgroundImage = useSettingsStore(state => state.setBackgroundImage)
  const setDynamicDock = useSettingsStore(state => state.setDynamicDock)
  const setWindowControlButtons = useSettingsStore(state => state.setWindowControlButtons)

  const windowControlButtonsOnRight = useSettingsStore(state => state.windowControlButtonsOnRight)
  const activeTab = useSettingsStore(state => state.activeTab)
  const theme = useSettingsStore(state => state.theme)
  const dynamicDock = useSettingsStore(state => state.dynamicDock)
  const notificationOnMusicPlay = useSettingsStore(state => state.notificationOnMusicPlay)
  const widgets = useSettingsStore(state => state.widgets)
  const backgroundImage = useSettingsStore(state => state.backgroundImage)
  const customWalls = useSettingsStore(state => state.customWalls)
  const settingsState = useMethodStore(state => state.settingsState)

  return (
    <div className={`bg-zinc-200/90 dark:bg-zinc-900/90 backdrop-blur-md ${settingsState === "maximized" ? "h-screen" : "w-full h-full lg:w-[900px] lg:h-[500px]"}`}>
      <VerticalTab className="h-full" value={activeTab} onValueChange={(value: string) => setActiveTab(value as settingsTabTypes)} orientation="vertical">
        <VerticalTabsList className={`bg-zinc-100 md:bg-zinc-100/70 dark:bg-zinc-800 fixed md:static w-screen h-full top-0 ${isOpen ? "left-0" : "-left-full"} transition-all duration-300 z-50 sm:w-fit`}>
          <VerticalTabsTrigger onClick={() => isOpen && setIsOpen(false)} value="general" className={`space-x-2 ${settingsState === "maximized" ? "w-full sm:w-64" : "w-full sm:w-64 md:w-48"}`}>
            <MdSettings className="text-lg" />
            <span className="text-base">General</span>
          </VerticalTabsTrigger>
          <VerticalTabsTrigger onClick={() => isOpen && setIsOpen(false)} value="widgets" className={`space-x-2 ${settingsState === "maximized" ? "w-full sm:w-64" : "w-full sm:w-64 md:w-48"}`}>
            <MdWidgets className="text-lg" />
            <span className="text-base">Widgets</span>
          </VerticalTabsTrigger>
          <Separator className="my-2 bg-zinc-300 dark:bg-zinc-700" />
          <VerticalTabsTrigger onClick={() => isOpen && setIsOpen(false)} value="wallpapers" className={`space-x-2 ${settingsState === "maximized" ? "w-full sm:w-64" : "w-full sm:w-64 md:w-48"}`}>
            <FaBrush className="text-lg" />
            <span className="text-base">Wallpapers</span>
          </VerticalTabsTrigger>
          <VerticalTabsTrigger onClick={() => isOpen && setIsOpen(false)} value="appearance" className={`space-x-2 ${settingsState === "maximized" ? "w-full sm:w-64" : "w-full sm:w-64 md:w-48"}`}>
            <FaPalette className="text-lg" />
            <span className="text-base">Appearance</span>
          </VerticalTabsTrigger>
          <Separator className="my-2 bg-zinc-300 dark:bg-zinc-700" />
          <VerticalTabsTrigger onClick={() => isOpen && setIsOpen(false)} value="music" className={`space-x-2 ${settingsState === "maximized" ? "w-full sm:w-64" : "w-full sm:w-64 md:w-48"}`}>
            <FaMusic />
            <span className="text-base">Music</span>
          </VerticalTabsTrigger>
          <VerticalTabsTrigger onClick={() => isOpen && setIsOpen(false)} value="chat" className={`space-x-2 ${settingsState === "maximized" ? "w-full sm:w-64" : "w-full sm:w-64 md:w-48"}`}>
            <IoChatbubble />
            <span className="text-base">Chat</span>
          </VerticalTabsTrigger>
          <Separator className="my-2 bg-zinc-300 dark:bg-zinc-700" />
          <VerticalTabsTrigger onClick={() => isOpen && setIsOpen(false)} value="about" className={`space-x-2 ${settingsState === "maximized" ? "w-full sm:w-64" : "w-full sm:w-64 md:w-48"}`}>
            <MdPerson4 />
            <span className="text-base">About</span>
          </VerticalTabsTrigger>
        </VerticalTabsList>

        {/* Content */}

        <VerticalTabsContent value="general" className="h-full w-full py-2 ml-2 pr-2 space-y-2">
          <Label htmlFor="search-shortcut" className={labelStyling}>
            <div className="space-y-1">
              <span className="text-sm font-medium">Enable dynamic dock</span>
              <p className="text-xs text-zinc-600 dark:text-zinc-400">Dock will automatically open and close based on your activity.</p>
            </div>
            <Switch id="search-shortcut" checked={dynamicDock} onCheckedChange={setDynamicDock} />
          </Label>
          <Label htmlFor="window-control-buttons" className={labelStyling}>
            <div className="space-y-1">
              <span className="text-sm font-medium">Window control buttons on right</span>
              <p className="text-xs text-zinc-600 dark:text-zinc-400">Window control buttons (eg. minimize, maximize and close buttons) will appear on the right side of the title bar.</p>
            </div>
            <Switch id="window-control-buttons" checked={windowControlButtonsOnRight} onCheckedChange={setWindowControlButtons} />
          </Label>
        </VerticalTabsContent>

        <VerticalTabsContent value="wallpapers" className="h-full w-full py-2 ml-2">
          <div className={`grid gap-2 ${settingsState === "maximized" ? "grid-cols-2 2xl:grid-cols-3 pb-12" : "grid-cols-2"} w-full h-full scroll2 pr-1 overflow-y-auto overflow-x-hidden`}>
            {wallpapers.map((src, index) => (
              <img onClick={() => setBackgroundImage(src)} className={`w-full ${settingsState === "maximized" ? "h-52 lg:h-60 xl:h-72" : "h-52"} bg-cover border-2 cursor-pointer ${src === backgroundImage ? "border-red-500" : "hover:border-zinc-500"}`} width={350} key={index} src={src} alt={src} />
            ))}
            {customWalls.map((src, index) => (
              <div className="relative group/wall">
                <img onClick={() => setBackgroundImage(src)} className={`w-full ${settingsState === "maximized" ? "h-52 lg:h-60 xl:h-72" : "h-52"} bg-cover border-2 cursor-pointer ${src === backgroundImage ? "border-red-500" : "hover:border-zinc-500"}`} width={350} key={index} src={src} alt={src} />
                <button onClick={() => removeCustomWall(src)} className="absolute top-2 right-2 p-2 rounded-sm text-zinc-100 bg-red-500/80 hover:bg-red-500 opacity-0 transition-opacity duration-200 group-hover/wall:opacity-100">
                  <FaTrash />
                </button>
              </div>
            ))}
            <Dialog onOpenChange={() => setPreviewWallpaper(null)}>
              <DialogTrigger className={`flex flex-col space-y-3 w-full ${settingsState === "maximized" ? "h-52 lg:h-60 xl:h-72" : "h-52"} justify-center items-center border-2 border-zinc-400 hover:bg-zinc-400/60 dark:border-zinc-700 dark:hover:bg-zinc-800/60 cursor-pointer`}>
                <FaPlus className="text-xl" />
                <span>Add wallpaper</span>
              </DialogTrigger>
              <DialogContent>
                <DialogHeader>
                  <DialogTitle>Add wallpaper</DialogTitle>
                  <DialogDescription>
                    Upload a new wallpaper or paste a link to an image
                  </DialogDescription>
                </DialogHeader>
                <ImageUploader setPreviewWallpaper={setPreviewWallpaper} previewWallpaper={previewWallpaper} />
              </DialogContent>
            </Dialog>
          </div>
        </VerticalTabsContent>

        <VerticalTabsContent value="music" className="h-full w-full py-2 ml-2 pr-2 space-y-2">
          <Label htmlFor="notification-on-music" className={labelStyling}>
            <div className="space-y-1">
              <span className="text-sm font-medium">Get notification on music play</span>
              <p className="text-xs text-zinc-600 dark:text-zinc-400">You will get a notification on each music play.</p>
            </div>
            <Switch id="notification-on-music" checked={notificationOnMusicPlay} onCheckedChange={setNotificationOnMusicPlay} />
          </Label>
        </VerticalTabsContent>

        <VerticalTabsContent value="chat" className="h-full w-full py-2 ml-2 pr-2 space-y-2">
          <ChatSettings labelStyling={labelStyling} />
        </VerticalTabsContent>

        <VerticalTabsContent value="widgets" className="h-full !w-full py-2 ml-2 pr-2 space-y-2">
          <Label htmlFor="music-widget" className={labelStyling}>
            <div className="space-y-1">
              <span className="text-sm font-medium">Music</span>
              <p className="text-xs text-zinc-600 dark:text-zinc-400">Toggle music widget.</p>
            </div>
            <Switch id="music-widget" checked={widgets.includes("Music")} onCheckedChange={(value) => value ? addWidget("Music") : removeWidget("Music")} />
          </Label>
          <Label htmlFor="quote-widget" className={labelStyling}>
            <div className="space-y-1">
              <span className="text-sm font-medium">Quotes</span>
              <p className="text-xs text-zinc-600 dark:text-zinc-400">Toggle quotes widget.</p>
            </div>
            <Switch id="quote-widget" checked={widgets.includes("Quotes")} onCheckedChange={(value) => value ? addWidget("Quotes") : removeWidget("Quotes")} />
          </Label>
          <Label htmlFor="note-widget" className={labelStyling}>
            <div className="space-y-1">
              <span className="text-sm font-medium">Notes</span>
              <p className="text-xs text-zinc-600 dark:text-zinc-400">Toggle notes widget.</p>
            </div>
            <Switch id="note-widget" checked={widgets.includes("Notes")} onCheckedChange={(value) => value ? addWidget("Notes") : removeWidget("Notes")} />
          </Label>
        </VerticalTabsContent>

        <VerticalTabsContent value="appearance" className="h-full w-full py-2 ml-2 pr-2 space-y-2">
          <Tabs defaultValue={theme} onValueChange={(value) => setTheme(value as ("light" | "dark"))} className="w-full">
            <TabsList className={`w-full h-60 sm:h-72 ${settingsState === "maximized" && "lg:h-96"}`}>
              <TabsTrigger className="w-full h-full flex flex-col justify-evenly" value="light">
                <img src="./settings/lightMode.png" alt="" />
                <span>Light Mode</span>
              </TabsTrigger>
              <TabsTrigger className="w-full h-full flex flex-col justify-evenly" value="dark">
                <img src="./settings/darkMode.png" alt="" />
                <span>Dark Mode</span>
              </TabsTrigger>
            </TabsList>
          </Tabs>
        </VerticalTabsContent>

        <VerticalTabsContent value="about" className="h-full w-full !mt-0 overflow-y-auto scroll2 py-2 ml-2 pr-2">
          <div className="space-y-2">
            <AboutSettings />
          </div>
        </VerticalTabsContent>

      </VerticalTab>
      <button onClick={() => setIsOpen(!isOpen)} className="fixed md:hidden z-[60] bottom-14 right-12 text-xl p-4 rounded-full text-zinc-900 bg-zinc-200 hover:bg-zinc-300 dark:text-zinc-100 dark:bg-zinc-700 dark:hover:bg-zinc-800 transition-colors duration-200">
        {isOpen ? <FaX /> : <IoMenu />}
      </button>
    </div >
  )
}

export default Settings